import { testUrl } from 'api/url'
import http from 'api/pureApi'
import { method } from 'lodash'

let secondUrl = '/nipponia-service'

if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
  const lin = testUrl
  secondUrl = lin
}

const api = {
  editPwd: {
    method: 'post',
    config: {
      url: '/v1/nipponia/reset-pwd',
      fields: ['loginName','oldPwd', 'pwd'],
    },
  },
  // 获取所有组织的导航
  getAllOrgNav: {
    method: 'get',
    config: {
      url: '/v1/nipponia/get-all-org-request-uri',
      fields: [],
    },
  },
  // 获取所有组织
  getAllOrg: {
    method: 'post',
    config: {
      url: '/v1/nipponia/get-org-info-list',
      fields: ['active'],
    },
  },
  // 获取组织通过id
  getOrgById: {
    method: 'get',
    config: {
      url: '/v1/nipponia/get-orginfo',
      fields: ['id'],
    },
  },
  // 获取组织的导航
  getOrgNavigationById: {
    method: 'get',
    config: {
      url: '/v1/nipponia/get-personal-info',
      fields: ['orgId', 'accId', 'orgCode'],
    },
  },
  getToolsById:{
    method: 'get',
    config: {
      url: '/v1/nipponia/get-tools',
      fields: ['orgId', 'accId', 'orgCode'],
    },
  }
}

function startReq({ name, data, _this }) {
  const current = api[name]
  const isHttpLink = current.config.url.startsWith('http')
  if (!isHttpLink) {
    current.config.url = !current.config.url.includes(secondUrl)
      ? secondUrl + current.config.url
      : current.config.url
  }
  const currentHeaders = {}

  return http[current.method]({
    data,
    headers: currentHeaders,
    config: current.config,
    _this,
  })
}

export default startReq
